import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DnnInterceptor } from '@2sic.com/dnn-sxc-angular';
import { StateService } from './state.service';
import { ResourceService } from './resources.service';

import { AppComponent } from './app.component';
import { StartComponent } from './start/start.component';
import { SendLinkComponent } from './send-link/send-link.component';
import { NewsletterApi } from './newsletter-api.service';
import { SettingsComponent } from './settings/settings.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { ErrorDisplayComponent } from './error-display/error-display.component';
import { HttpLoadingInterceptorProvider } from './http-loading-interceptor';
import { LinkSentComponent } from './link-sent/link-sent.component';


const appRoutes: Routes = [
  { path: '', component: StartComponent },
  { path: 'send-link', component: SendLinkComponent },
  { path: 'link-sent', component: LinkSentComponent },
  { path: 'settings', component: SettingsComponent }
];


@NgModule({
  declarations: [
    AppComponent,
    StartComponent,
    SendLinkComponent,
    SettingsComponent,
    LoadingSpinnerComponent,
    ErrorDisplayComponent,
    LinkSentComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(
      appRoutes,
      //{ enableTracing: true }  <-- debugging purposes only
    ),
    FormsModule,
    HttpClientModule
  ],
  providers: [
    StateService, 
    DnnInterceptor,
    NewsletterApi,
    HttpLoadingInterceptorProvider,
    ResourceService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
